export default {
    small: [0, 599],
    medium: [600, 899],
    normal: [900, 1299],
    large: [1300, null],
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov/platform-settings/settings/breakpoints.js